exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".TextBoxGroup__root{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:8px}.TextBoxGroup__heading{font-weight:600}\n", "", {"version":3,"sources":["/home/runner/work/gl-web-react-ui/gl-web-react-ui/web/js/components/common/TextBoxGroup/TextBoxGroup.scss"],"names":[],"mappings":"AAAA,oBAAM,oBAAoB,aAAa,0BAA0B,sBAAsB,OAAO,CAAC,uBAAS,eAAe,CAAC","file":"TextBoxGroup.scss","sourcesContent":[".root{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:8px}.heading{font-weight:600}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"root": "TextBoxGroup__root",
	"heading": "TextBoxGroup__heading"
};